import { BasicLayout, RouteView } from '@/layouts'

const managesystem = {
  path: '/',
  name: 'shouye',
  component: BasicLayout,
  meta: {
    title: '首页'
  },
  children: [
    {
      path: '/',
      name: 'gerenzhongxin',
      component: RouteView,
      meta: {
        title: '个人中心',
        keepAlive: true,
        icon: 'setting'
      },
      children: [
        {
          path: '/gr/profile',
          name: 'gerenxinxi',
          component: () => import('../views/managesystem/gr/profile/index.vue'),
          meta: {
            title: '个人信息',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr01',
          name: 'xuexijingli',
          component: () => import('../views/managesystem/gr/gr01/index.vue'),
          meta: {
            title: '学习经历',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr01/gr01dtl',
          name: 'gr01dtl',
          component: () => import('../views/managesystem/gr/gr01/gr01dtl.vue'),
          meta: {
            title: '学习经历 / 学习经历详细',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr02',
          name: 'gr02',
          component: () => import('../views/managesystem/gr/gr02/index.vue'),
          meta: {
            title: '工作经历',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr02/gr02dtl',
          name: 'gr02dtl',
          component: () => import('../views/managesystem/gr/gr02/gr02dtl.vue'),
          meta: {
            title: '工作经历 / 工作经历详细',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr03',
          name: 'gr03',
          component: () => import('../views/managesystem/gr/gr03/index.vue'),
          meta: {
            title: '学术任职',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr03/gr03dtl',
          name: 'gr03dtl',
          component: () => import('../views/managesystem/gr/gr03/gr03dtl.vue'),
          meta: {
            title: '学术任职 / 学术任职详细',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr04',
          name: 'gr04',
          component: () => import('../views/managesystem/gr/gr04/index.vue'),
          meta: {
            title: '荣誉嘉奖',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr04/gr04dtl',
          name: 'gr04dtl',
          component: () => import('../views/managesystem/gr/gr04/gr04dtl.vue'),
          meta: {
            title: '荣誉嘉奖 / 荣誉嘉奖详细',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr05',
          name: 'gr05',
          component: () => import('../views/managesystem/gr/gr05/index.vue'),
          meta: {
            title: '个人简介',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr05/gr05dtl',
          name: 'gr05dtl',
          component: () => import('../views/managesystem/gr/gr05/gr05dtl.vue'),
          meta: {
            title: '个人简介 / 个人简介详细',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr06',
          name: 'gr06',
          component: () => import('../views/managesystem/gr/gr06/index.vue'),
          meta: {
            title: '个人简历',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr06/gr06dtl',
          name: 'gr06dtl',
          component: () => import('../views/managesystem/gr/gr06/gr06dtl.vue'),
          meta: {
            title: '个人简历 / 个人简历详细',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr07',
          name: 'gr07',
          component: () => import('../views/managesystem/gr/gr07/index.vue'),
          meta: {
            title: '招聘应聘',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr0702',
          name: 'gr0702',
          component: () => import('../views/managesystem/gr/gr07/mypublish.vue'),
          meta: {
            title: '我的发布',
            keepAlive: true
          }
        },
        {
          path: '/gr/gr0703',
          name: 'gr0703',
          component: () => import('../views/managesystem/gr/gr07/send-list.vue'),
          meta: {
            title: '投递详情',
            keepAlive: true
          }
        },
        {
          path: '/testapi',
          name: 'testapi',
          component: () => import(/* webpackChunkName: "about" */ '../views/managesystem/temp/testapi.vue'),
          meta: {
            title: 'api测试',
            keepAlive: true
          }
        }
      ]
    },
    {
      path: '/',
      name: 'gongzuoguanli',
      component: RouteView,
      meta: {
        title: '工作管理',
        keepAlive: true,
        icon: 'setting'
      },
      children: [
        {
          path: '/gz/jx/jx01',
          name: 'jx01',
          component: () => import('../views/managesystem/gz/jx/jx01/index.vue'),
          meta: {
            title: '教学管理 / 课程管理',
            keepAlive: true
          }
        },
        {
          path: '/gz/jx/jx01dtl',
          name: 'jx01dtl',
          component: () => import('../views/managesystem/gz/jx/jx01/jx01dtl.vue'),
          meta: {
            title: '教学管理 / 教改课题详细',
            keepAlive: true
          }
        },
        {
          path: '/gz/jx/jx01detail',
          name: 'kechengdetail',
          component: () => import('../views/managesystem/gz/jx/jx01/detail/index.vue'),
          meta: {
            title: '教学管理 / 课程管理详细',
            keepAlive: true
          }
        },
        {
          path: '/gz/jx/jx02',
          name: 'jx02',
          component: () => import('../views/managesystem/gz/jx/jx02/index.vue'),
          meta: {
            title: '教学管理 / 教改课题',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx02dtl',
          name: 'jx02dtl',
          component: () => import('../views/managesystem/gz/jx/jx02/jx02dtl.vue'),
          meta: {
            title: '教学管理 / 教改课题详细',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx0203',
          name: 'jx0203',
          component: () => import('@/views/managesystem/gz/jx/jx0203/index'),
          meta: {
            title: '教学管理 / 课题经费',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx0204',
          name: 'jx0204',
          component: () => import('@/views/managesystem/gz/jx/jx0204/index'),
          meta: {
            title: '教学管理 / 课题研讨',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx0205',
          name: 'jx0205',
          component: () => import('@/views/managesystem/gz/jx/jx0205/index'),
          meta: {
            title: '教学管理 / 研讨详情',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx0206',
          name: 'jx0206',
          component: () => import('@/views/managesystem/gz/jx/jx0206/index'),
          meta: {
            title: '教学管理 / 参会人',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx0207',
          name: 'jx0207',
          component: () => import('@/views/managesystem/gz/jx/jx0207/index'),
          meta: {
            title: '教学管理 / 参会单位',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx0208',
          name: 'jx0208',
          component: () => import('@/views/managesystem/gz/jx/jx0208/index'),
          meta: {
            title: '教学管理 / 研讨内容',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx0209',
          name: 'jx0209',
          component: () => import('@/views/managesystem/gz/jx/jx0209/index'),
          meta: {
            title: '教学管理 / 研讨结果',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx03',
          name: 'jx03',
          component: () => import('../views/managesystem/gz/jx/jx03/index.vue'),
          meta: {
            title: '教学管理 / 教学论文',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx03dtl',
          name: 'jx03dtl',
          component: () => import('../views/managesystem/gz/jx/jx03/jx03dtl.vue'),
          meta: {
            title: '教学管理 /教学论文详细',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx04',
          name: 'jx04',
          component: () => import('@/views/managesystem/gz/jx/jx04/index.vue'),
          meta: {
            title: '教学管理 / 教材编写',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx04dtl',
          name: 'jx04dtl',
          component: () => import('@/views/managesystem/gz/jx/jx04/jx04dtl.vue'),
          meta: {
            title: '教学管理 / 教材编写详细',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx05',
          name: 'jx05',
          component: () => import('@/views/managesystem/gz/jx/jx05/index.vue'),
          meta: {
            title: '教学管理 / 教学成果',
            keepAlive: true
          }
        }, {
          path: '/gz/jx/jx05dtl',
          name: 'jx05dtl',
          component: () => import('@/views/managesystem/gz/jx/jx05/jx05dtl.vue'),
          meta: {
            title: '教学管理 / 教学成果详细',
            keepAlive: true
          }
        }, {
          path: '/gz/xz/xz01',
          name: 'xz01',
          component: () => import('@/views/managesystem/gz/xz/xz01/index.vue'),
          meta: {
            title: '行政管理 / 任务管理',
            keepAlive: true
          }
        }, {
          path: '/gz/xz/xz01dtl',
          name: 'xz01dtl',
          component: () => import('@/views/managesystem/gz/xz/xz01/xz01dtl.vue'),
          meta: {
            title: '行政管理 / 任务管理详细',
            keepAlive: true
          }
        }, {
          path: '/gz/xz/xz02',
          name: 'xz02',
          component: () => import('@/views/managesystem/gz/xz/xz02/index.vue'),
          meta: {
            title: '行政管理 / 事务管理',
            keepAlive: true
          }
        }, {
          path: '/gz/xz/xz02dtl',
          name: 'xz02dtl',
          component: () => import('@/views/managesystem/gz/xz/xz02/xz02dtl.vue'),
          meta: {
            title: '行政管理 / 事务管理详细',
            keepAlive: true
          }
        }, {
          path: '/gz/xz/xz03',
          name: 'xz03',
          component: () => import('@/views/managesystem/gz/xz/xz03/index.vue'),
          meta: {
            title: '行政管理 / 制度管理',
            keepAlive: true
          }
        }, {
          path: '/gz/xz/xz03dtl',
          name: 'xz03dtl',
          component: () => import('@/views/managesystem/gz/xz/xz03/xz03dtl.vue'),
          meta: {
            title: '行政管理 / 制度管理详细',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs01',
          name: 'xs01',
          component: () => import('@/views/managesystem/gz/xs/xs01/index.vue'),
          meta: {
            title: '行政管理 / 学术任职',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs01dtl',
          name: 'xs01dtl',
          component: () => import('@/views/managesystem/gz/xs/xs01/xs01dtl.vue'),
          meta: {
            title: '行政管理 / 学术任职详细',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs0103',
          name: 'xs0103',
          component: () => import('@/views/managesystem/gz/xs/xs0103/index'),
          meta: {
            title: '行政管理 / 学术任职 / 管理机构',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs0104',
          name: 'xs0104',
          component: () => import('@/views/managesystem/gz/xs/xs0104/index'),
          meta: {
            title: '行政管理 / 学术任职 / 讨论会',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs0105',
          name: 'xs0105',
          component: () => import('@/views/managesystem/gz/xs/xs0105/index'),
          meta: {
            title: '行政管理 / 学术任职 / 讨论会详情',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs0106',
          name: 'xs0106',
          component: () => import('@/views/managesystem/gz/xs/xs0106/index'),
          meta: {
            title: '行政管理 / 学术任职 / 参会人',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs0107',
          name: 'xs0107',
          component: () => import('@/views/managesystem/gz/xs/xs0107/index'),
          meta: {
            title: '行政管理 / 学术任职 / 参会单位',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs0108',
          name: 'xs0108',
          component: () => import('@/views/managesystem/gz/xs/xs0108/index'),
          meta: {
            title: '行政管理 / 学术任职 / 研讨内容',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs0109',
          name: 'xs0109',
          component: () => import('@/views/managesystem/gz/xs/xs0109/index'),
          meta: {
            title: '行政管理 / 学术任职 / 研讨结果',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs02',
          name: 'xs02',
          component: () => import('@/views/managesystem/gz/xs/xs02/index.vue'),
          meta: {
            title: '行政管理 / 评审咨询',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs02dtl',
          name: 'xs02dtl',
          component: () => import('@/views/managesystem/gz/xs/xs02/xs02dtl.vue'),
          meta: {
            title: '行政管理 / 评审咨询详细',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs0202',
          name: 'xs0202',
          component: () => import('@/views/managesystem/gz/xs/xs0202/index'),
          meta: {
            title: '行政管理 / 评审咨询 / 项目清单',
            keepAlive: true
          }
        }, {
          path: '/gz/xs/xs0203',
          name: 'xs0203',
          component: () => import('@/views/managesystem/gz/xs/xs0203/index'),
          meta: {
            title: '行政管理 / 评审咨询 / 主管单位',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky01',
          name: 'ky01',
          component: () => import('@/views/managesystem/gz/ky/ky01/index.vue'),
          meta: {
            title: '行政管理 / 我的实验',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky01dtl',
          name: 'ky01dtl',
          component: () => import('@/views/managesystem/gz/ky/ky01/ky01dtl.vue'),
          meta: {
            title: '行政管理 / 我的实验详细',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky02',
          name: 'ky02',
          component: () => import('@/views/managesystem/gz/ky/ky02/index.vue'),
          meta: {
            title: '行政管理 / 项目课题',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky02dtl',
          name: 'ky02dtl',
          component: () => import('@/views/managesystem/gz/ky/ky02/ky02dtl.vue'),
          meta: {
            title: '行政管理 / 项目课题详细',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky03',
          name: 'ky03',
          component: () => import('@/views/managesystem/gz/ky/ky03/index.vue'),
          meta: {
            title: '行政管理 / 发表论文',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky03dtl',
          name: 'ky03dtl',
          component: () => import('@/views/managesystem/gz/ky/ky03/ky03dtl.vue'),
          meta: {
            title: '行政管理 / 发表论文详细',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky04',
          name: 'ky04',
          component: () => import('@/views/managesystem/gz/ky/ky04/index.vue'),
          meta: {
            title: '行政管理 / 编写专著',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky04dtl',
          name: 'ky04dtl',
          component: () => import('@/views/managesystem/gz/ky/ky04/ky04dtl.vue'),
          meta: {
            title: '行政管理 / 编写专著详细',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0402',
          name: 'ky0402',
          component: () => import('@/views/managesystem/gz/ky/ky0402/index'),
          meta: {
            title: '行政管理 / 编写专著 / 参编者',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0403',
          name: 'ky0403',
          component: () => import('@/views/managesystem/gz/ky/ky0403/index'),
          meta: {
            title: '行政管理 / 编写专著 / 参编单位',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky05',
          name: 'ky05',
          component: () => import('@/views/managesystem/gz/ky/ky05/index.vue'),
          meta: {
            title: '行政管理 / 申报专利',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky05dtl',
          name: 'ky05dtl',
          component: () => import('@/views/managesystem/gz/ky/ky05/ky05dtl.vue'),
          meta: {
            title: '行政管理 / 申报专利详细',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0502',
          name: 'ky0502',
          component: () => import('@/views/managesystem/gz/ky/ky0502/index'),
          meta: {
            title: '行政管理 / 申报专利 / 参编发明人',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0503',
          name: 'ky0503',
          component: () => import('@/views/managesystem/gz/ky/ky0503/index'),
          meta: {
            title: '行政管理 / 申报专利 / 申请（专利权）人',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0504',
          name: 'ky0504',
          component: () => import('@/views/managesystem/gz/ky/ky0504/index'),
          meta: {
            title: '行政管理 / 申报专利 / 受理单位',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0505',
          name: 'ky0505',
          component: () => import('@/views/managesystem/gz/ky/ky0505/index'),
          meta: {
            title: '行政管理 / 申报专利 / 代理机构',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky06',
          name: 'ky06',
          component: () => import('@/views/managesystem/gz/ky/ky06/index.vue'),
          meta: {
            title: '行政管理 / 产品批件',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky06dtl',
          name: 'ky06dtl',
          component: () => import('@/views/managesystem/gz/ky/ky06/ky06dtl.vue'),
          meta: {
            title: '行政管理 / 产品批件详细',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0602',
          name: 'ky0602',
          component: () => import('@/views/managesystem/gz/ky/ky0602/index'),
          meta: {
            title: '行政管理 / 产品批件 / 发明人',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0603',
          name: 'ky0603',
          component: () => import('@/views/managesystem/gz/ky/ky0603/index'),
          meta: {
            title: '行政管理 / 产品批件 / 申请（专利权）人',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0604',
          name: 'ky0604',
          component: () => import('@/views/managesystem/gz/ky/ky0604/index'),
          meta: {
            title: '行政管理 / 产品批件 / 受理单位',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0605',
          name: 'ky0605',
          component: () => import('@/views/managesystem/gz/ky/ky0605/index'),
          meta: {
            title: '行政管理 / 产品批件 / 代理机构',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky07',
          name: 'ky07',
          component: () => import('@/views/managesystem/gz/ky/ky07/index.vue'),
          meta: {
            title: '行政管理 / 成果奖项',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky07dtl',
          name: 'ky07dtl',
          component: () => import('@/views/managesystem/gz/ky/ky07/ky07dtl.vue'),
          meta: {
            title: '行政管理 / 成果奖项详细',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0702',
          name: 'ky0702',
          component: () => import('@/views/managesystem/gz/ky/ky0702/index'),
          meta: {
            title: '行政管理 / 成果奖项 / 发明人',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0703',
          name: 'ky0703',
          component: () => import('@/views/managesystem/gz/ky/ky0703/index'),
          meta: {
            title: '行政管理 / 成果奖项 / 完成单位',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0704',
          name: 'ky0704',
          component: () => import('@/views/managesystem/gz/ky/ky0704/index'),
          meta: {
            title: '行政管理 / 成果奖项 / 受理单位',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0705',
          name: 'ky0705',
          component: () => import('@/views/managesystem/gz/ky/ky0705/index'),
          meta: {
            title: '行政管理 / 成果奖项 / 代理机构',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky08',
          name: 'ky08',
          component: () => import('@/views/managesystem/gz/ky/ky08/index.vue'),
          meta: {
            title: '行政管理 / 成果转化',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky08dtl',
          name: 'ky08dtl',
          component: () => import('@/views/managesystem/gz/ky/ky08/ky08dtl.vue'),
          meta: {
            title: '行政管理 / 成果转化详细',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0802',
          name: 'ky0802',
          component: () => import('@/views/managesystem/gz/ky/ky0802/index'),
          meta: {
            title: '行政管理 / 成果转化 / 管理团队',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0803',
          name: 'ky0803',
          component: () => import('@/views/managesystem/gz/ky/ky0803/index'),
          meta: {
            title: '行政管理 / 成果转化 / 完成人',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0804',
          name: 'ky0804',
          component: () => import('@/views/managesystem/gz/ky/ky0804/index'),
          meta: {
            title: '行政管理 / 成果转化 / 完成单位',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0805',
          name: 'ky0805',
          component: () => import('@/views/managesystem/gz/ky/ky0805/index'),
          meta: {
            title: '行政管理 / 成果转化 / 应用情况',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0806',
          name: 'ky0806',
          component: () => import('@/views/managesystem/gz/ky/ky0806/index'),
          meta: {
            title: '行政管理 / 成果转化 / 经济效益',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0807',
          name: 'ky0807',
          component: () => import('@/views/managesystem/gz/ky/ky0807/index'),
          meta: {
            title: '行政管理 / 成果转化 / 产权情况',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0808',
          name: 'ky0808',
          component: () => import('@/views/managesystem/gz/ky/ky0808/index'),
          meta: {
            title: '行政管理 / 成果转化 / 批件情况',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0809',
          name: 'ky0809',
          component: () => import('@/views/managesystem/gz/ky/ky0809/index'),
          meta: {
            title: '行政管理 / 成果转化 / 成果奖项',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0810',
          name: 'ky0810',
          component: () => import('@/views/managesystem/gz/ky/ky0810/index'),
          meta: {
            title: '行政管理 / 成果转化 / 资助课题',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky0811',
          name: 'ky0811',
          component: () => import('@/views/managesystem/gz/ky/ky0811/index'),
          meta: {
            title: '行政管理 / 成果转化 / 发表论文',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky09',
          name: 'ky09',
          component: () => import('@/views/managesystem/gz/ky/ky09/index.vue'),
          meta: {
            title: '行政管理 / SOP',
            keepAlive: true
          }
        }, {
          path: '/gz/ky/ky09dtl',
          name: 'ky09dtl',
          component: () => import('@/views/managesystem/gz/ky/ky09/ky09dtl.vue'),
          meta: {
            title: '行政管理 / SOP详细',
            keepAlive: true
          }
        }

      ]
    },
    // 团队管理
    {
      path: '/',
      name: 'td',
      component: RouteView,
      meta: {
        title: '团队管理',
        keepAlive: true,
        icon: 'setting'
      },
      children: [
        {
          path: '/td/td01',
          name: 'td01',
          component: () => import('@/views/managesystem/td/td01/index.vue'),
          meta: {
            title: '我的好友',
            keepAlive: true
          }
        },
        {
          path: '/td/contactview',
          name: 'contactview',
          component: () => import('@/views/managesystem/td/td01/contactview.vue'),
          meta: {
            title: '查看好友详情',
            keepAlive: true
          }
        },
        {
          path: '/td/contactdtl',
          name: 'contactdtl',
          component: () => import('@/views/managesystem/td/td01/contactdtl.vue'),
          meta: {
            title: '通讯录详细',
            keepAlive: true
          }
        },
        {
          path: '/td/td02',
          name: 'td02',
          component: () => import('@/views/managesystem/td/td02/index.vue'),
          meta: {
            title: '科研团队',
            keepAlive: true
          }
        },
        {
          path: '/td/td03',
          name: 'td03',
          component: () => import('@/views/managesystem/td/td03/index.vue'),
          meta: {
            title: '合作团队',
            keepAlive: true
          }
        },
        {
          path: '/td/td04',
          name: 'td04',
          component: () => import('@/views/managesystem/td/td04/index.vue'),
          meta: {
            title: '临时团队',
            keepAlive: true
          }
        },
        {
          path: '/td/td05',
          name: 'td05',
          component: () => import('@/views/managesystem/td/td05/index.vue'),
          meta: {
            title: '历史团队',
            keepAlive: true
          }
        },
        {
          path: '/td/td06',
          name: 'td06',
          component: () => import('@/views/managesystem/td/td06/index.vue'),
          meta: {
            title: '科研团队组织架构',
            keepAlive: true
          }
        },
        {
          path: '/td/td07',
          name: 'td07',
          component: () => import('@/views/managesystem/td/td07/index.vue'),
          meta: {
            title: '单位信息',
            keepAlive: true
          }
        },
        {
          path: '/td/td07dtl',
          name: 'td07dtl',
          component: () => import('@/views/managesystem/td/td07/endUserDanWeidtl.vue'),
          meta: {
            title: '单位详细信息',
            keepAlive: true
          }
        }
      ]
    },
    // 资源管理
    {
      path: '/',
      name: 'zy',
      component: RouteView,
      meta: {
        title: '资源管理',
        keepAlive: true,
        icon: 'setting'
      },
      children: [
        {
          path: '/zy/zy02',
          name: 'zy02',
          component: () => import('@/views/managesystem/zy/zy02/index.vue'),
          meta: {
            title: '试剂耗材',
            keepAlive: true
          }
        },
        {
          path: '/zy/zy0201',
          name: 'zy0201',
          component: () => import('@/views/managesystem/zy/zy0201/index.vue'),
          meta: {
            title: '试剂耗材入出库详细',
            keepAlive: true
          }
        }, {
          path: '/zy/zy0202',
          name: 'zy0202',
          component: () => import('@/views/managesystem/zy/zy0202/index.vue'),
          meta: {
            title: '试剂耗材申领发放',
            keepAlive: true
          }
        }, {
          path: '/zy/zy0203',
          name: 'zy0203',
          component: () => import('@/views/managesystem/zy/zy0203/index.vue'),
          meta: {
            title: '申领管理',
            keepAlive: true
          }
        }, {
          path: '/zy/zy0204',
          name: 'zy0204',
          component: () => import('@/views/managesystem/zy/zy0204/index.vue'),
          meta: {
            title: '课题管理',
            keepAlive: true
          }
        },
        {
          path: '/zy/zy03',
          name: 'zy03',
          component: () => import('@/views/managesystem/zy/zy03/index.vue'),
          meta: {
            title: '技术服务',
            keepAlive: true
          }
        },
        {
          path: '/zy/zy03dtl',
          name: 'zy03dtl',
          component: () => import('@/views/managesystem/zy/zy03/zy03dtl.vue'),
          meta: {
            title: '技术服务详细',
            keepAlive: true
          }
        }

      ]
    },
    // 头部
    {
      // 事件
      path: '/',
      name: 'header',
      component: RouteView,
      meta: {
        title: '综合',
        keepAlive: true,
        icon: 'setting'
      },
      children: [
        {
          path: '/header/evenement',
          name: 'evenement',
          component: () => import('@/views/Home/headerevenement.vue'),
          meta: {
            title: '事件',
            keepAlive: true
          }
        },
        {
          path: '/header/calendar',
          name: 'calendar',
          component: () => import('@/views/Home/headercalendar.vue'),
          meta: {
            title: '日程',
            keepAlive: true
          }
        },
        {
          path: '/header/notice',
          name: 'notice',
          component: () => import('@/views/Home/headernotice.vue'),
          meta: {
            title: '通知',
            keepAlive: true
          }
        },
        {
          path: '/header/navi',
          name: 'navi',
          component: () => import('@/views/Home/headernavi.vue'),
          meta: {
            title: '导航',
            keepAlive: true
          }
        },
        {
          path: '/eventnode',
          name: 'eventnode',
          component: () => import('@/views/managesystem/gz/com/WorkEventNode.vue'),
          meta: {
            title: '事件',
            keepAlive: true
          }
        },
        {
          path: '/diarylist',
          name: 'diarylist',
          component: () => import('@/views/Home/diarylist.vue'),
          meta: {
            title: '日记本',
            keepAlive: true
          }
        }
      ]
    }
  ]
}
export default {
  managesystem
}
